import { render, staticRenderFns } from "./ChangeInboundReference.vue?vue&type=template&id=42ca8da6&"
import script from "./ChangeInboundReference.vue?vue&type=script&lang=js&"
export * from "./ChangeInboundReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports